import type { RecordingCountCondition } from "@repo/app-types/entities/filterConditions";
import type { FC, ReactNode } from "react";
import { RemoveFilterChip } from "./filterChip.js";

export interface RecordingCountFilterItemProps {
  value: RecordingCountCondition | null;
  onChange: (newValue: RecordingCountCondition | null) => void;
}

export const RecordingCountFilterItem: FC<RecordingCountFilterItemProps> = (
  props,
) => {
  if (props.value === null) {
    return null;
  }

  return (
    <RemoveFilterChip onRemove={() => props.onChange(null)}>
      {renderCondition(props.value)}
    </RemoveFilterChip>
  );
};

function renderCondition(condition: RecordingCountCondition): ReactNode {
  const calls = `${condition.value} ${condition.value === 1 ? "call" : "calls"}`;

  switch (condition.operator) {
    case "=":
      return calls;
    case "<":
      return `Fewer than ${calls}`;
    case "<=":
      return `At most ${calls}`;
    case ">":
      return `More than ${calls}`;
    case ">=":
      return `At least ${calls}`;
    default:
      return "Invalid condition";
  }
}
